import { useUnit } from 'effector-react';
import html2canvas from 'html2canvas';
import { memo, useCallback } from 'react';
import { setIsPostCardPreparing, setPostCardCanvas } from 'src/entity/PostCard';
import { $isUserUseMobileApp } from 'src/entity/User';
import downloadPostCard from 'src/shared/assets/images/downloadPostCard.png';
import { PostCardActionIcon } from 'src/shared/ui/postCardActionIcon/PostCardActionIcon';

import bridge from '@vkontakte/vk-bridge';

import { setIsSavePostCard } from '../model/SavePostcard';

interface ISavePostCardProps {
  savingElement: HTMLDivElement | null;
}

export const SavePostCard = memo(({ savingElement }: ISavePostCardProps) => {
  const [
    onSetPostCardCanvas,
    onSetIsPostCardPreparing,
    isUserUseMobileApp
  ] = useUnit([
    setPostCardCanvas,
    setIsPostCardPreparing,
    $isUserUseMobileApp
  ]);

  console.log(window.innerHeight);

  const onDownloadClickHandler = useCallback(async () => {
    // @ts-ignore
    bridge.send('VKWebAppSendCustomEvent', {
      event: 'download_diplom_click'
    });

    if (!savingElement) {
      return;
    }
    onSetIsPostCardPreparing(true);
    setIsSavePostCard(true);
    const canvas = await html2canvas(savingElement, {
      removeContainer: true,
      backgroundColor: 'rgba(0, 0, 255, 1)',
      allowTaint: false,
      scale: 5,
      height: (navigator.maxTouchPoints && window.innerHeight > 650)
        ? 650
        : window.innerHeight
    });
    onSetPostCardCanvas(canvas);
  }, [onSetIsPostCardPreparing, onSetPostCardCanvas, savingElement]);

  return (
    <PostCardActionIcon
      onClick={onDownloadClickHandler}
      image={downloadPostCard}
      direction='right'
    />
  );
});
